/**
 * Convert number to US locale.
 * @example from 1000 to 1,000
 */
export const getFormattedCurrency = (currency: number): string => currency
  .toLocaleString('en-US', { style: 'currency', currency: 'USD' });
